<template>
  <div class="w-100" v-if="bookingStore.prix_total == 0">
    <v-btn @click="handle_free_checkout()" :loading="loading" color="primary-dark" block
      class="sm-fullwidth mt-4 checkout_btn" variant="tonal" size="default"> <v-icon
        icon="mdi-arrow-right-bold"></v-icon> Valider ma commande</v-btn>
  </div>
  <div class="w-100" v-else>
    <v-btn @click="handle_checkout()" :loading="loading" color="primary-dark" block
      class="sm-fullwidth mt-4 checkout_btn" variant="tonal" size="default"> <v-icon
        icon="mdi-arrow-right-bold"></v-icon> Accèder au paiement</v-btn>
    <div class="d-flex justify-center mb-3 w-100">
      <div class="bg-white pa-1 rounded mt-3">
        <img class="logo_paiement" src="https://sportips.fr/images/logo_securise.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useBookingStore } from "@/stores/bookingStore";

export default {
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapStores(useBookingStore),
  },
  methods: {
    handle_free_checkout() {
      this.loading = true;
      this.$emit("onFreeCheckout");
    },
    handle_checkout() {
      this.loading = true;
      this.$emit("onAccessCheckout");
    }
  }
};
</script>

<style lang="scss" scoped>
.logo_paiement {
  width: 150px;
  max-width: 100%;
  height: auto;
}
</style>